import { rhodolite } from "@latticexyz/common/chains";
import { anvil } from "./anvil";
import { webSocket } from "viem";

export const transports = {
  [anvil.id]: webSocket(),
  [rhodolite.id]: webSocket(),
};
